import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SettingsService } from '../../../core/http/settings.service';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-sub-department-modal',
  templateUrl: './sub-department-modal.component.html',
  styleUrls: ['./sub-department-modal.component.scss']
})
export class SubDepartmentModalComponent implements OnInit {

  isLoading = true;
  Errors = null;
  titles = null;
  depts = null;
  groups = null;
  mode = null;
  data = null
  Success = null

  deptForm = new FormGroup({
    name: new FormControl('', Validators.required),
    dept_id: new FormControl('', Validators.required),
    group_id: new FormControl('', Validators.required),
    status: new FormControl('', Validators.required),
    id: new FormControl(null, Validators.required),
  });


  constructor(private modal: ModalService, private _snackBar: MatSnackBar, public auth: SettingsService) { }

  onSubmit(e) {
    e.preventDefault();
    this.isLoading = true;
    this.Errors = null;
    this.Success = null;
    const {
      name,
        dept_id,
        group_id,
        status,
        id,
    } = this.deptForm.value;
    this.auth
      .postSubDept(
        name,
        dept_id,
        group_id,
        status,
        id,
      )
      .subscribe(
        (resSuccess) => {

          this.data = resSuccess
          this.isLoading = false;
          console.log(resSuccess)

          if (this.data.success) {
            this.closeModal()
            this._snackBar.open('Saved Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });           }
          else {
            this.Errors = "Not successful, please try again"
            console.log("error")
          }
          
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
          console.log(resErr)
        }
      );
  }

  closeModal() {
    this.modal.closeModal();
  }

  ngOnInit(): void {

    this.auth
    .getDept()
    .subscribe(
      (resSuccess) => {

        this.depts = resSuccess
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );

    this.auth
    .getGroups()
    .subscribe(
      (resSuccess) => {

        this.groups = resSuccess
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );

    this.auth
      .getSubDept()
      .subscribe(
        (resSuccess) => {

          this.titles = resSuccess
          this.isLoading = false;
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
        }
      ); 
  }

  addNew() {
    this.mode = "add"
  }
  edit(title) {
    this.mode = "edit"
    this.deptForm.patchValue({
      name: title.name,
      dept_name: title.dept_id,
      group_name: title.dept_id,
      status: title.status,
      id: title.id,
    });
    console.log(title.id)
  }

  delete(title) {
    this.auth
      .delSet("/api/departments/deleteSubDept", title.id)
      .subscribe(
        (resSuccess) => {
          this.titles = this.titles.filter(dattum => dattum.id !== title.id)
          this._snackBar.open('Deleted Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        },
        (resErr) => {
          this._snackBar.open('Error try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }
      );
  }

}
